import React from 'react';
import { IconBase } from '../Base';
export const IconReturn = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M9.28338 14.3789H11.427C13.4002 14.3789 14.9998 12.7793 14.9998 10.8061V10.8061C14.9998 8.83297 13.4002 7.2334 11.427 7.2334H4.99609", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } }),
        React.createElement("path", { d: "M7.85429 10.0914L4.99609 7.23319L7.85429 4.375", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } })));
};
//# sourceMappingURL=Return.js.map